import React, {memo} from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {ModalSheet} from '../../../../components/common/ModalSheet/ModalSheet';
import {ConfirmButton} from '../styled';
import {ContentButtonModal, TitleModal, WrapperText} from './styled';

type SuccessModalProps = {
  isOpen: boolean;
  close: () => void;
  confirmUrlTo: string;
  onBackClick: () => void;
};
const SuccessModal = memo(
  ({isOpen, close, confirmUrlTo, onBackClick}: SuccessModalProps) => {
    const {t} = useTranslation();
    const navigate = useNavigate();

    return (
      <ModalSheet
        isOpenModalSheet={isOpen}
        handleCloseModal={close}
        title={t('tourist_taxes_setup_complete_exclamation')}
        className="tax-setup-success-modal"
      >
        <WrapperText>
          <TitleModal className="tax-setup-success-modal__title">
            {t('you_can_continue_directly_to_payment')}
          </TitleModal>

          <ContentButtonModal className="tax-setup-success-modal__btns">
            <ConfirmButton onClick={() => navigate(confirmUrlTo)}>
              {t('continue_to_payment')}
            </ConfirmButton>
            <ConfirmButton onClick={onBackClick} variant="link">
              {t('back_to_home')}
            </ConfirmButton>
          </ContentButtonModal>
        </WrapperText>
      </ModalSheet>
    );
  },
);

export {SuccessModal};
